<template>
	<div class="o-card" :class="classes">
		<slot />
	</div>
</template>

<script>
export default {
	// This is the default background, box shadow, and border-radius part of cards. No border, no padding, no margin.
	name: "OpreCard",
	props: {
		classes: {
			type: Object,
			required: false,
			default: () => ({}),
		},
	}
};
</script>

<style scoped lang="scss">
.o-card {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05), 0px 2px 1px rgba(0, 0, 0, 0.05), 0px 1px 1px rgba(114, 54, 22, 0.03), 0px 0px 1px rgba(122, 58, 6, 0.08);
  transition: box-shadow 0.1s ease-out;

  &::before, &::after {
    content: '';
    border-radius: 8px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05), 0px 1px 1px rgba(114, 54, 22, 0.03);
  }

  &:hover {
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05), 0px 3px 12px rgba(114, 54, 22, 0.03), 0px 2px 1px rgba(122, 58, 6, 0.08);

    &::before, &::after {
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05), 0px 3px 12px rgba(114, 54, 22, 0.03), 0px 2px 1px rgba(122, 58, 6, 0.08);
    }
  }
}
</style>
